export default __webpack_public_path__ + "static/media/riverwalk_bridge.ae4a5415.jpg";